export default __webpack_public_path__ + "static/media/Needlebag.987a6491.jpg";